import { render, staticRenderFns } from "./BulkItem.vue?vue&type=template&id=3250d44e&scoped=true"
import script from "./BulkItem.vue?vue&type=script&lang=js"
export * from "./BulkItem.vue?vue&type=script&lang=js"
import style0 from "./BulkItem.vue?vue&type=style&index=0&id=3250d44e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250d44e",
  null
  
)

export default component.exports